module.exports = __webpack_public_path__ + "img/COMPASS_9001_circle.c0a9defb.png";